import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

function AccessDenied() {
  return (
    <div className="content p-5">
      <h1>Access denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}

export default function ProtectedRoute({
  permission,
  permissions,
  requireAll = false,
  redirectTo = '/portfolio',
  children
}) {
  const location = useLocation();
  const { isAuthLoading, isAuthenticated, hasPermission, hasAllPermissions } = useAuth();

  if (isAuthLoading) {
    return (
      <div className="content p-5">
        <p>Checking permissions...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const requiredPermissions = permissions || (permission ? [permission] : []);
  const isAllowed = requireAll
    ? hasAllPermissions(requiredPermissions)
    : hasPermission(requiredPermissions);

  if (!isAllowed) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    return <AccessDenied />;
  }

  return children;
}
